<template>
<form class="form contact-form" method="post" @submit.prevent="submit">
    <h2 class="title is-5">EMAIL US</h2>
    <p class="subtitle is-7"><em><span class="has-text-danger">*</span> Indicates required field</em></p>
    <fieldset :disabled="is_loading">
        <div class="field is-horizontal">
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input class="input" type="text" placeholder="First Name (*)" required v-model="first_name" />
                    </p>
                </div>
                <div class="field">
                    <p class="control">
                        <input class="input" type="text" placeholder="Last Name (*)" required v-model="surname" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field">
            <div class="control">
                <input class="input" type="email" v-model="email" placeholder="Email (*)" required />
            </div>
        </div>
        <div class="field">
            <div class="control">
                <textarea class="textarea" v-model="content" placeholder="How can we help? (*)" required></textarea>
            </div>
        </div>
        <div class="actions field">
            <vue-recaptcha ref="recaptcha" class="field" @verify="verify" @expired="expired" :sitekey="site_key" :loadRecaptchaScript="true"></vue-recaptcha>
            <div :class="'notification field is-' + postback.type" v-if="postback.message">
                <button class="delete" @click.prevent="postback.message = null;"></button>
                {{postback.message}}
            </div>
            <button type="submit" :class="['button is-black', {'is-loading': is_loading}]">Submit</button>
        </div>
    </fieldset>
</form>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
    name    :   'ContactForm',
    props   :   ['site_key'],
    components  :   { VueRecaptcha },
    data()
    {
        return {
            is_loading  :   false,
            first_name  :   null,
            surname     :   null,
            email       :   null,
            content     :   null,
            recap_resp  :   null,
            postback    :   {
                type    :   'succes',
                message :   null
            }
        };
    },
    methods :
    {
        expired() {
            this.recap_resp =   false;
        },
        verify(resp) {
            this.recap_resp =   resp;
        },
        submit(e)
        {
            if (!this.recap_resp) {
                alert('Please verify you are not a robot!');
                return false;
            }

            if (this.is_loading) return false;
            this.is_loading =   true;

            let me      =   this,
                data    =   new FormData();

            data.append('csrf', csrf);
            data.append('first_name', this.first_name);
            data.append('surname', this.surname);
            data.append('content', this.content);
            data.append('email', this.email);
            data.append('recap_resp', this.recap_resp);
            axios.post(
                base_url + endpoints.contact,
                data
            ).then((resp) => {
                this.is_loading =   false;
                this.first_name =   null;
                this.surname    =   null;
                this.email      =   null;
                this.content    =   null;
                this.recap_resp =   null;
                this.$refs.recaptcha.reset();
                this.postback.type      =   'success';
                this.postback.message   =   resp.data.message;
                // this.$bus.$emit('onShowMessage', resp.data.message, 'success', 'Contact Message Sent');
            }).catch((error) => {
                this.is_loading =   false;
                this.postback.type      =   'danger';
                this.postback.message   =   error.response.data.message;
                // this.$bus.$emit('onShowMessage', error.response.data.message, 'danger', 'Contact Message Failed');
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/forms/ContactForm.vue